

function dealerUserManagement() {

    let profileService = [
        {
            name: "User Management",
            icon: "User Management",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerUserManagement",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerUserManagement",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    const userManagement = () => {
        const profileArr = [
            {
                path: "/index/userManagement",
                name: "User Management",
                icon: "fee-master",
                logoName: "userManagement",
            },
        ];
        return profileArr;
    };


    let a = dashboard();
    let b = userManagement();

    profileService[0].items = [...a, ...b];

    return profileService;
}

export default dealerUserManagement;
